import { isBefore } from "date-fns";
import { IdentifiedPatientState } from "./consent.dtos";
import { StudyStatus } from "./study.dtos";
export function documentDeliveryCoversStudy(delivery, studyId) {
    var _a;
    return delivery.initiatingStudyId === studyId || ((_a = delivery.additionalStudyIds) !== null && _a !== void 0 ? _a : []).includes(studyId);
}
export function isPatientConsentWalletEnrolled(state) {
    return state === IdentifiedPatientState.ENROLLED || state === IdentifiedPatientState.REMOVED;
}
export function isPatientConsentEnrolledActionNeeded(consent) {
    if (consent.pending)
        return false;
    if (!isPatientConsentWalletEnrolled(consent.state))
        return false;
    return !!consent.updateRecordsNeeded || !!consent.recordsRetrievalNeeded;
}
export function isPatientActivelySharingConsent(consent) {
    if (consent.pending)
        return false;
    if (!isPatientConsentWalletEnrolled(consent.state))
        return false;
    return !consent.updateRecordsNeeded && !consent.recordsRetrievalNeeded;
}
export function isProjectActiveForSharing(study) {
    return ![StudyStatus.COMPLETED, StudyStatus.WITHDRAWN].includes(study.status) && !study.isCompletionDateExpired;
}
export function isProjectActiveForSharingByCompletionDate(status, completionDate) {
    if ([StudyStatus.COMPLETED, StudyStatus.WITHDRAWN].includes(status))
        return false;
    if (completionDate === null || completionDate === undefined)
        return true;
    return isBefore(new Date(), new Date(completionDate));
}
